module.exports = __webpack_public_path__ + "assets/img/station16.583e2ef7.png";